import React, { useEffect, useState } from "react";
import { Link} from "react-router-dom";

import FeatherIcon from "feather-icons-react";
import Scrollbars from "react-custom-scrollbars-2";
import { hooks } from "../../studentportal-sdk";
import { history } from "../../_components/_helpers/history";
import $ from "jquery";
// import { LogoImg, LogoSmallImg } from "../_components/imagepath";

const Sidebar = (props) => {
  const [isSideMenu, setSideMenu] = useState("");

  const toggleSidebar = (value) => {
    setSideMenu(value);
  };

  useEffect(() => {
    function handleMouseOver(e) {
      e.stopPropagation();
      if (
        document.body.classList.contains("mini-sidebar") &&
        document.querySelector("#toggle_btn").offsetParent !== null
      ) {
        var targ = e.target.closest(".sidebar");
        if (targ) {
          document.body.classList.add("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "block"));
        } else {
          document.body.classList.remove("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "none"));
        }
        return false;
      }
    }

    document.addEventListener("mouseover", handleMouseOver);

    return () => {
      document.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  useEffect(() => {
    $(document).on("change", ".sidebar-type-four input", function () {
      if ($(this).is(":checked")) {
        $(".sidebar").addClass("sidebar-eight");
        $(".sidebar-menu").addClass("sidebar-menu-eight");
        $(".menu-title").addClass("menu-title-eight");
        $(".header").addClass("header-eight");
        $(".header-left-two").addClass("header-left-eight");
        $(".user-menu").addClass("user-menu-eight");
        $(".dropdown-toggle").addClass("dropdown-toggle-eight");
        $(".white-logo").addClass("show-logo");
        $(
          ".header-one .header-left-one .logo:not(.logo-small), .header-five .header-left-five .logo:not(.logo-small)"
        ).addClass("hide-logo");
        $(".header-two .header-left-two .logo:not(.logo-small)").removeClass(
          "hide-logo"
        );
        $(".header-two .header-left-two .dark-logo").removeClass("show-logo");
      } else {
        $(".sidebar").removeClass("sidebar-eight");
        $(".sidebar-menu").removeClass("sidebar-menu-eight");
        $(".menu-title").removeClass("menu-title-eight");
        $(".header").removeClass("header-eight");
        $(".header-left-two").removeClass("header-left-eight");
        $(".user-menu").removeClass("user-menu-eight");
        $(".dropdown-toggle").removeClass("dropdown-toggle-eight");
        $(".white-logo").removeClass("show-logo");
        $(
          ".header-one .header-left-one .logo:not(.logo-small), .header-five .header-left-five .logo:not(.logo-small)"
        ).removeClass("hide-logo");
      }
    });
  }, []);

  let pathName = history.location.pathname;

  const {
    authService: {
      action: { userLogout },
    },
  } = props;

  return (
    <>
      <div className="sidebar" id="sidebar">
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              {/* Students */}
              <ul>
                <li className="menu-title">
                  <span>Main Menu</span>
                </li>
                <li
                  className={`${
                    "/studentdashboard" === pathName
                      ? "active submenu"
                      : "submenu"
                  }`}
                >
                  <Link
                    to="#"
                    className={isSideMenu === "index" ? "subdrop" : ""}
                    onClick={() =>
                      toggleSidebar(isSideMenu === "index" ? "" : "index")
                    }
                  >
                    <FeatherIcon icon="grid" /> <span>Dashboard</span>{" "}
                    <span className="menu-arrow"></span>
                  </Link>
                  {isSideMenu === "index" ? (
                    <ul
                      style={{
                        display: isSideMenu === "index" ? "block" : "none",
                      }}
                    >
                      <li>
                        <Link
                          to="/studentdashboard"
                          className={`${
                            "/studentdashboard" === pathName ? "active" : ""
                          }`}
                        >
                          Dashboard
                        </Link>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
              </ul>
              <ul>
                <li className="menu-title">
                  <span>Course Overview</span>
                </li>
                <li
                  className={`${"/modules" === pathName || "/general-entry-level" === pathName || "/level-1"}`}
                >
                  <Link to="/courses">
                    <i className="fas fa-book" />
                    <span>Course Library</span>
                  </Link>
                </li>
                {/* <li
                  className={`${
                    "/assessments" === pathName ||
                    "/upcoming" === pathName ||
                    "/available" === pathName ||
                    "/completed" === pathName ||
                    "/grades" === pathName
                      ? "active submenu"
                      : "submenu"
                  }`}
                >
                  <Link
                    to="#"
                    className={isSideMenu === "Assessments" ? "subdrop" : ""}
                    onClick={() =>
                      toggleSidebar(
                        isSideMenu === "Assessments" ? "" : "Assessments"
                      )
                    }
                  >
                    <i className="fas fa-award" />
                    <span>My Assessments</span>
                    <span className="menu-arrow" />
                  </Link>
                  {isSideMenu === "Assessments" ? (
                    <ul
                      style={{
                        display: isSideMenu === "Assessments" ? "block" : "none",
                      }}
                    >
                      <li>
                        <Link
                          to="/upcoming"
                          className={`${
                            "/upcoming" === pathName ? "active" : ""
                          }`}
                        >
                          Upcoming Assessments
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/available"
                          className={`${
                            "/available" === pathName ? "active" : ""
                          }`}
                        >
                          Available Assessments
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/completed"
                          className={`${
                            "/completed" === pathName ? "active" : ""
                          }`}
                        >
                          Completed Assessments
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/grades"
                          className={`${
                            "/grades" === pathName ? "active" : ""
                          }`}
                        >
                          Grades & Feedback
                        </Link>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </li> */}
                <li
                  className={`${
                    "/assessments" === pathName ||
                    "/viewassessment" === pathName ||
                    "/addassessment" === pathName ||
                    "/editassessment" === pathName ||
                    "/addassessmentquestions" === pathName ||
                    "/enrolledassessment" === pathName
                      ? "active submenu"
                      : "submenu"
                  }`}
                >
                  <Link
                    to="#"
                    className={isSideMenu === "Assessments" ? "subdrop" : ""}
                    onClick={() =>
                      toggleSidebar(
                        isSideMenu === "Assessments" ? "" : "Assessments"
                      )
                    }
                  >
                    <i className="fas fa-graduation-cap" />{" "}
                    <span> Assessments</span> <span className="menu-arrow" />
                  </Link>
                  {isSideMenu === "Assessments" ? (
                    <ul
                      style={{
                        display: isSideMenu === "Assessments" ? "block" : "none",
                      }}
                    >
                      <li>
                        <Link
                          to="/assessments"
                          className={`${
                            "/assessments" === pathName ? "active" : ""
                          }`}
                        >
                          My Assessments
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/enrolledassessments"
                          className={`${
                            "/enrolledassessments" === pathName ? "active" : ""
                          }`}
                        >
                          Enrolled Assessments
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/viewassessment"
                          className={`${
                            "/viewassessment" === pathName ? "active" : ""
                          }`}
                        >
                          View Assessments
                        </Link>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
                {/* <li>
                  <Link to="/resources">
                    <i className="fas fa-book" /> <span>Resources</span>
                  </Link>
                </li> */}
                <li>
                  <Link to="/livesession">
                    <i className="fas fa-video" />
                    <span>Live Class</span>
                  </Link>
                </li>
              </ul>

              {/* Management */}
              <ul>
                {/* <li
                  className={`${
                    "/event" === pathName || "/event" === pathName
                      ? "active"
                      : ""
                  }`}
                >
                  <Link to="/event">
                    <i className="fas fa-calendar-day" /> <span>Calendar</span>
                  </Link>
                </li>
                {/* <li
                  className={`${
                    "/timetable" === pathName ||
                    "/addtimetable" === pathName ||
                    "/edittimetable" === pathName
                      ? "active"
                      : ""
                  }`}
                >
                  <Link to="/timetable">
                    <i className="fas fa-table" /> <span>Schedule</span>
                  </Link>
                </li> */}

                <li className={`${"/profile" === pathName ? "active" : ""}`}>
                  <Link to="/profile">
                    <i className="fas fa-user" /> <span>Profile</span>
                  </Link>
                </li>
                <li
                  className={`${
                    "/login" === pathName || "/othersettings" === pathName
                      ? "active"
                      : ""
                  }`}
                >
                  <Link to="#" onClick={() => userLogout()}>
                    <i className="fas fa-sign-out" /> <span>Logout</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};
// export default withRouter(Sidebar);
export default (props) => <Sidebar {...hooks.authentication(props)} />; // eslint-disable-line

